import { render, staticRenderFns } from "./CustomFieldDropdown.vue?vue&type=template&id=1e08819e"
import script from "./CustomFieldDropdown.vue?vue&type=script&lang=js"
export * from "./CustomFieldDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports